import React from 'react'

import Welcome from '../Welcome'
import Result from '../Result'
import MainScreen from '../MainScreen'

import 'normalize.css/normalize.css'
import './general.css'
import classes from './styles'

const lsKey = 'currentPostIndex'
const racKey = 'rightAnswerCount'

class App extends React.Component {
  constructor(props) {
    super(props)

    // const currentPostIndex = localStorage.getItem(lsKey)
    const currentPostIndex = null
    const rightAnswerCount = null
    if (! currentPostIndex) {
      localStorage.setItem(lsKey, 0)
    }

    if (! rightAnswerCount) {
      localStorage.setItem(racKey, 0)
    }

    this.state = {
      currentPostIndex: currentPostIndex || 0,
      rightAnswerCount: rightAnswerCount || 0,
    }
  }

  nextPost = () => {
    const currentPostIndex = Number(localStorage.getItem(lsKey))
    const nextPostIndex = currentPostIndex ? currentPostIndex + 1 : 1
    localStorage.setItem(lsKey, nextPostIndex)

    this.setState({ currentPostIndex: nextPostIndex })
  }

  addToRightAnswerCount = (rightAnswerCountInRound) => {
    const currentRightAnswerCount = Number(localStorage.getItem(racKey))
    const nextRightAnswerCount = currentRightAnswerCount + rightAnswerCountInRound
    localStorage.setItem(racKey, nextRightAnswerCount)

    this.setState({ rightAnswerCount: nextRightAnswerCount })
  }

  reset = () => {
    this.setState({
      currentPostIndex: 0
    })
    localStorage.setItem(lsKey, 0)
  }

  render() {
    const { isStarted, posts, actions } = this.props
    const currentPost = posts[this.state.currentPostIndex]
    const isNextPostExist = Boolean(posts[Number(this.state.currentPostIndex) + 1])

    return (
      <div className={classes.app}>
        <img className={[classes.leftTop, classes.angle].join(' ')} src="https://10years.lifehacker.ru/static/images/rounded.svg" alt=""/>
        <img className={[classes.rightTop, classes.angle].join(' ')} src="https://10years.lifehacker.ru/static/images/rounded.svg" alt=""/>
        <img className={[classes.leftBottom, classes.angle].join(' ')} src="https://10years.lifehacker.ru/static/images/rounded.svg" alt=""/>
        <img className={[classes.rightBottom, classes.angle].join(' ')} src="https://10years.lifehacker.ru/static/images/rounded.svg" alt=""/>

        {isStarted ?
          <div style={{ height: '100%' }}>
            {currentPost ?
              <MainScreen
                post={currentPost}
                next={this.nextPost}
                currentPostIndex={this.state.currentPostIndex}
                addToRightAnswerCount={this.addToRightAnswerCount}
                rightAnswerCount={this.state.rightAnswerCount}
              />
              :
              <Result
                rightAnswerCount={this.state.rightAnswerCount}
                currentPostIndex={this.state.currentPostIndex}
              />
            }
          </div>
          :
          <Welcome isLoading={false} start={actions.start} />
        }
      </div>
    )
  }
}

App.propTypes = {
  isStarted: React.PropTypes.bool.isRequired,
  actions: React.PropTypes.object.isRequired,
  posts: React.PropTypes.array.isRequired,
}

export default App



// WEBPACK FOOTER //
// ./src/components/App/App.jsx